import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, offerHighlights, PACK_IMAGE, PRICE, PRODUCT_TM } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precio" className="border-y-4 border-solar bg-navy" data-id="element-135" data-mp="1j9738oiouhxc">
      <div className="mx-auto max-w-page px-3 py-5 text-center sm:px-6 sm:py-7" data-id="element-136" data-mp="1n9r2pyqqhxmn">
        <Reveal data-id="element-137" data-mp="1s8u5tdn5ltrz">
          <p className="text-[0.7rem] font-black uppercase tracking-[0.26em] text-solar sm:text-[0.78rem]" data-id="element-138" data-mp="1s8c6g8572zfu">
            🔥 Oferta especial de lanzamiento
          </p>
          <h2 id="precio" className="mt-0.5 font-display text-xl uppercase leading-[1.04] text-white sm:text-3xl" data-id="element-139" data-mp="228cpdsz5jdji">
            ☀️ {PRODUCT_TM}
          </h2>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-2.5 max-w-2xl rounded-xl border-2 border-solar bg-white p-3 sm:p-4" data-id="element-140" data-mp="7t0g4pfnikjc">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" data-id="element-141" data-mp="1miraucpijyxi">
            <img src={PACK_IMAGE} alt={`${PRODUCT_TM}: 6 módulos y 5 bonos incluidos`} className="mx-auto w-full max-w-xs rounded-lg border border-navy/15" data-id="element-142" data-mp="1hodhefuew1vh" />
          </a>

          <p className="mt-2 font-display text-lg uppercase text-navy sm:text-2xl" data-id="element-143" data-mp="17pxny67wwgit">
            6 Módulos + 5 Bonos
          </p>

          <ul className="mt-2 grid gap-1 text-left sm:grid-cols-2" data-id="element-144" data-mp="20fxwqg5jadqy">
            {offerHighlights.map(item => <li key={item} className="flex items-center gap-2 rounded-md bg-azure-soft px-2.5 py-1.5 text-[0.74rem] font-bold uppercase text-navy sm:text-[0.78rem]" data-id="element-145" data-mp="1vgbhk165anfi">
                <CheckIcon size={13} className="flex-shrink-0 text-azure" strokeWidth={3} data-id="element-146" data-mp="k3r5sr4rxkev" />
                {item}
              </li>)}
          </ul>

          <p className="mt-2 rounded-md bg-solar px-3 py-1.5 text-[0.74rem] font-black uppercase leading-snug text-coal sm:text-[0.8rem]" data-id="element-147" data-mp="hfx7xj6sz5j2">
            🎁 + 5 Bonos valorados en {BONUS_VALUE}
          </p>

          <p className="mt-2 text-[0.66rem] font-black uppercase tracking-[0.24em] text-steel sm:text-[0.72rem]" data-id="element-148" data-mp="cionfby6mpen">
            Hoy todo por solo:
          </p>
          <p className="font-display text-4xl leading-none text-navy sm:text-6xl" data-id="element-149" data-mp="3uv3a4fg9ri14">
            ☀️ {PRICE} ☀️
          </p>
          <p className="mt-0.5 font-condensed text-lg uppercase tracking-wide text-azure sm:text-2xl" data-id="element-150" data-mp="3k3abwbhc2l9">
            Pago único
          </p>
          <p className="text-[0.66rem] font-semibold uppercase tracking-wide text-steel sm:text-[0.72rem]" data-id="element-151" data-mp="3px1t002elssa">
            Sin mensualidades • Acceso Digital
          </p>

          <div className="mt-2.5 flex flex-col items-center gap-1" data-id="element-152" data-mp="3c067371206ut">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-153" data-mp="3fyvtfp42kyql">
              🔥 ¡SÍ! QUIERO EL SISTEMA COMPLETO POR {PRICE}
            </CtaButton>
            <p className="flex items-center gap-1.5 text-[0.66rem] font-bold uppercase tracking-wide text-steel sm:text-[0.72rem]" data-id="element-154" data-mp="2sca0778kmwia">
              <ShieldCheckIcon size={13} className="text-gold" data-id="element-155" data-mp="36culca1yl4ey" />
              🛡️ Garantía de Devolución de 30 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}